import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchContraReturn, fetchStitchContReGrp, fetchStitchingReturnlist, fetchStitchReturnGrpStid, fetchStitchReturnGrpStid2 } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchContraReturn, selectStitchContReGrp, selectStitchReGrpStId, selectStitchReGrpStId2, selectStkBarcode, selectStockMemoNo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StockMenu } from '../TitleList';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchStkReturnBarcode, fetchStockMemoNo, insertStockEntryProduction } from '../../Store/PHPSlice/Stock/StockApis';
import { fetchContractorReGrplist2, fetchContractorReturnlist } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { selectContReGrplist2, selectContReturnlist } from '../Selectors/Master/ItemSelectors';


const StockEntryProduction = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        sreId: '',
        sreMemo: '',
        stkMemo: '',
        stkReBar: '',
        streId: '',
        cutopk: '',
        stopk: '',
        depart: '',
        item: '',
        itemId: '',
        empNm: '',
        empId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        soId: '',
        sono: '',
        totQty: '',
        instructions: '',
        userId: '1',
        infoItemNm: '',
        infoItemId: ''
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [itemData, setItemData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [entries, setEntries] = useState([]);
    const [consolidatedArray, setConsolidatedArray] = useState([]);

    // Step 2: Function to process data2 and return the consolidated array
    const processData = (stReturnInfo) => {
        // Flattening the data if Info is available and has length greater than 0
        const data2 = stReturnInfo?.Info?.length > 0
            ? stReturnInfo.Info.flatMap(subArray => subArray.map(obj => obj))
            : [];

        // Reducing the data2 into consolidatedArray
        return data2.reduce((acc, curr) => {
            // Check if the size already exists in the accumulator
            const existing = acc.find(item => item.size === curr.size);

            if (existing) {
                // If it exists, sum up the quantities
                existing.rqty += Number(curr.rbqty);
                existing.dqty += Number(curr.dqty);
                existing.rbqty += Number(curr.rbqty);
            } else {
                // Otherwise, add a new entry
                acc.push({
                    size: curr.size,
                    issqty: curr.issqty,
                    rqty: Number(curr.rbqty),
                    dqty: Number(curr.dqty),
                    issueqty: '',
                    balqty: ''
                });
            }

            return acc;
        }, []);
    };

    // Step 2: Function to process data2 and return the consolidated array
    const processData2 = (cutContReInfo) => {
        // Flattening the data if Info is available and has length greater than 0
        const data2 = cutContReInfo?.returnInfo?.length > 0
            ? cutContReInfo.returnInfo
            : [];

        // Reducing the data2 into consolidatedArray
        return data2.reduce((acc, curr) => {
            // Check if the size already exists in the accumulator
            const existing = acc.find(item => item.size === curr.size);

            if (existing) {
                // If it exists, sum up the quantities
                existing.rqty += Number(curr.rbqty);
                existing.dqty += Number(curr.dqty);
            } else {
                // Otherwise, add a new entry
                acc.push({
                    ID: curr.ID,
                    size: curr.size,
                    rqty: Number(curr.rbqty),
                    dqty: Number(curr.dqty),
                    issueqty: '',
                    balqty: ''
                });
            }

            return acc;
        }, []);
    };

    const actionMap = {
        master: fetchStitchingReturnlist,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const departlist = useSelector(selectDaparement);
    const stkmemo = useSelector(selectStockMemoNo);
    const stReturndata = useSelector(selectStitchReGrpStId);
    const stReturnInfo = useSelector(selectStitchReGrpStId2);
    const cutContractorlist = useSelector(selectContReturnlist);
    const cutContReInfo = useSelector(selectContReturnlist);
    const stContralist = useSelector(selectStitchContraReturn);
    const stitchContInfo = useSelector(selectStitchContReGrp)

    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchStockMemoNo());
        dispatch(fetchStitchReturnGrpStid());
        dispatch(fetchContractorReturnlist());
        dispatch(fetchStitchContraReturn());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (stReturnInfo) {
            // Call the processData function when stReturnInfo changes
            const result = processData(stReturnInfo);
            setConsolidatedArray(result);
        }
    }, [stReturnInfo]);

    useEffect(() => {
        if (cutContReInfo) {
            // Call the processData function when stReturnInfo changes
            const result = processData2(cutContReInfo);
            setConsolidatedArray(result);
        }
    }, [cutContReInfo]);


    useEffect(() => {
        if (stitchContInfo) {
            // Call the processData function when stReturnInfo changes
            const result = processData(stitchContInfo);
            setConsolidatedArray(result);
        }
    }, [stitchContInfo]);

    useEffect(() => {
        if (stkmemo?.data) {
            const item = stkmemo?.data?.stkMemo;
            setFormData(prev => ({
                ...prev,
                stkMemo: item
            }))
        }
    }, [stkmemo]);


    useEffect(() => {
        if (stReturnInfo?.data.length > 0) {
            const item = stReturnInfo?.data;
            const val = item ? item[0] : '';
            setFormData(prev => ({
                ...prev,
                infoItemNm: val.itemNm,
                infoItemId: val.itemId,
                mcloth: val.mcloth,
                m1cloth: val.m1cloth,
                m2cloth: val.m2cloth,
                m3cloth: val.m3cloth,
                soId: val.soId,
                sono: val.sono,
                empId: val.empId,
                empNm: val.empNm
            }));
        }
    }, [stReturnInfo]);


    useEffect(() => {
        if (cutContReInfo?.data.length > 0) {
            const item = cutContReInfo?.data;
            const val = item ? item[0] : '';
            setFormData(prev => ({
                ...prev,
                infoItemNm: val.itemNm,
                infoItemId: val.itemId,
                mcloth: val.mcloth,
                m1cloth: val.m1cloth,
                m2cloth: val.m2cloth,
                m3cloth: val.m3cloth,
                soId: val.soId,
                sono: val.sono,
                empId: val.empId,
                empNm: val.empNm
            }));
        }
    }, [cutContReInfo]);

    useEffect(() => {
        if (stitchContInfo?.data.length > 0) {
            const item = stitchContInfo?.data;
            const val = item ? item[0] : '';
            setFormData(prev => ({
                ...prev,
                infoItemNm: val.itemNm,
                infoItemId: val.itemId,
                mcloth: val.mcloth,
                m1cloth: val.m1cloth,
                m2cloth: val.m2cloth,
                m3cloth: val.m3cloth,
                soId: val.soId,
                sono: val.sono,
                empId: val.empId,
                empNm: val.empNm
            }));
        }
    }, [stitchContInfo]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    // For filteredDepart:
    const filteredDepart = (departlist?.data && Array.isArray(departlist.data) && departlist.data.length > 0)
        ? departlist.data.filter(item => item.departNm === 'CUT-TO-PACK' || item.departNm === 'STITCH-TO-PACK' || item.departNm === 'STITCHING')
        : [];

    // For filterStitchingReturnlist:
    const filterStitchingReturnlist = (stReturndata?.data && Array.isArray(stReturndata.data) && stReturndata.data.length > 0)
        ? stReturndata.data.map(({ stId, stMemo }) => ({ stId, stMemo }))
        : [];

    // For filterCutToPacklist:
    const filterCutToPacklist = (cutContractorlist?.data && Array.isArray(cutContractorlist.data) && cutContractorlist.data.length > 0)
        ? cutContractorlist.data.map(({ ID, reMemo }) => ({ ID, reMemo }))
        : [];


    const filterStitchToPack = (stContralist && stContralist.data && Array.isArray(stContralist.data))
        ? stContralist.data.map(({ stId, reMemo }) => ({ stId, reMemo }))
        : [];


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'streId':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid2(value));
                }
                break;
            case 'cutopk':
                if (value) {
                    dispatch(fetchContractorReturnlist(value));

                }
                break;
            case 'stopk':
                if (value) {
                    dispatch(fetchStitchContReGrp(value));
                }
                break;
        }
    };

    const handleIssueQtyChange = (index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            const newData = [...consolidatedArray];
            const issueQty = Math.min(value, newData[index].rqty); // Ensure issueQty is not greater than remainqty
            newData[index].issueqty = issueQty;
            newData[index].balqty = newData[index].rqty - issueQty; // Calculate balance qty
            setConsolidatedArray(newData);
        }
    };


    const handleAddClick = () => {
        const department = filteredDepart.find(item => item.departNm == formData.depart);
        const departId = department ? department.ID : '';
        var stId = 0;
        var cutId = 0;
        var streId = 0;
        if (formData.streId !== '') {
            stId = formData.streId;
        } else if (formData.stopk !== '') {
            streId = formData.stopk;
        } else if (formData.cutopk !== '') {
            cutId = formData.cutopk;
        }

        const qty_size = consolidatedArray.reduce((acc, item) => {
            acc[item.size] = item.issueqty;
            return acc;
        }, {});
        const entries = {
            departNm: formData.depart,
            departId: departId,
            barcode: formData.stkBarcode,
            itemNm: formData.infoItemNm,
            itemId: formData.infoItemId,
            size: consolidatedArray.map((item) => item.size),
            qty: consolidatedArray.map((item) => item.rqty),
            inwqty: consolidatedArray.map(item => item.issueqty),
            stId: stId,
            cutId: cutId,
            soId: formData.soId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            empId: formData.empId,
            qty_size: qty_size,
            streId: streId
        };
        const calSktReBar = parseInt(formData.stkBarcode) + 1;
        setEntries(prev => ([...prev, entries]));
        setFormData(prev => ({
            ...prev,
            stkBarcode: calSktReBar,
            infoItemNm: '',
            depart: '',
            stopk: '',
            streId: '',
            cutopk: '',
            soId: '',
            mcloth: '',
            m1cloth: "",
            m2cloth: '',
            m3cloth: '',
            empId: ""

        }));
        setConsolidatedArray([]);
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.empNm) newErrors.empNm = 'empNm is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    function convertIntoOneObject(entries, formData) {
        const data = {
            entries: entries,
            dt: formData.dt,
            stkMemo: formData.stkMemo,
            userId: formData.userId,
        };
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = convertIntoOneObject(entries, formData);
        console.log(finalObject);

        dispatch(insertStockEntryProduction(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Kaje Press Added");
                // window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    return (
        <>
            <TitleBar data={StockMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Entry Production Wise</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
                                    { label: 'Barcode', name: 'stkBarcode', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="depart">Department:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="depart"
                                                    name="depart"
                                                    options={filteredDepart}
                                                    getOptionLabel={(option) => option.departNm || ''}
                                                    value={filteredDepart.find(item => item.departNm === formData.depart) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'depart', value: newValue ? newValue.departNm : '' } }, 'depart')}
                                                    // onOpen={() => handleDropdownOpen('reMemo')}
                                                    // onClose={() => handleDropdownClose('reMemo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.departNm === value.departNm}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.depart === 'STITCHING' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="streId">Stitching No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="streId"
                                                        name="streId"
                                                        options={filterStitchingReturnlist}
                                                        getOptionLabel={(option) => option.stMemo || ''}
                                                        value={filterStitchingReturnlist.find(item => item.stId === formData.streId) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'streId', value: newValue ? newValue.stId : '' } }, 'streId')}
                                                        // onOpen={() => handleDropdownOpen('reMemo')}
                                                        // onClose={() => handleDropdownClose('reMemo')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.stId === value.stId}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.depart === 'CUT-TO-PACK' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="cutopk">Cutting Return No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="cutopk"
                                                        name="cutopk"
                                                        options={filterCutToPacklist}
                                                        getOptionLabel={(option) => option.reMemo || ''}
                                                        value={filterCutToPacklist.find(item => item.ID === formData.cutopk) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'cutopk', value: newValue ? newValue.ID : '' } }, 'cutopk')}
                                                        // onOpen={() => handleDropdownOpen('reMemo')}
                                                        // onClose={() => handleDropdownClose('reMemo')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.depart === 'STITCH-TO-PACK' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="stopk">Stitching Return No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="stopk"
                                                        name="stopk"
                                                        options={filterStitchToPack}
                                                        getOptionLabel={(option) => option.reMemo || ''}
                                                        value={filterStitchToPack.find(item => item.stId === formData.stopk) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'stopk', value: newValue ? newValue.stId : '' } }, 'stopk')}
                                                        // onOpen={() => handleDropdownOpen('reMemo')}
                                                        // onClose={() => handleDropdownClose('reMemo')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.stId === value.stId}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {Array.isArray(consolidatedArray) && consolidatedArray.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, width: '60%' }}>
                                            <Table>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw Qty.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    </TableRow>
                                                    {
                                                        consolidatedArray.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{formData.infoItemNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.rqty}</TableCell>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.issueqty || ''}
                                                                        onChange={(e) => handleIssueQtyChange(index, Number(e.target.value))}
                                                                        min="0"
                                                                        max={item.remainqty} // Set max limit to remain qty
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.balqty}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Grid item xs={8} textAlign="center" sx={{ mt: '2vh' }}>
                                            <Button variant="contained" color="primary" onClick={handleAddClick}>Add</Button>
                                        </Grid>
                                    </>
                                }


                                {Array.isArray(entries) && entries.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Deparment</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Barcode</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw Qty.</TableCell>
                                                    </TableRow>
                                                    {
                                                        entries.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.departNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.barcode}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{(item.size).join(',')}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{(item.qty).join(',')}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{(item.inwqty).join(',')}</TableCell>

                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StockEntryProduction;
